var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeviceAccessTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 13.4545C8.27333 13.4545 8.5 13.2278 8.5 12.9545C8.5 12.6811 8.27333 12.4545 8 12.4545C7.72667 12.4545 7.5 12.6811 7.5 12.9545C7.5 13.2278 7.72667 13.4545 8 13.4545Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2334 15.0011H4.76669C4.48003 15.0011 4.20669 14.8878 4.00669 14.6878C3.80669 14.4878 3.69336 14.2145 3.69336 13.9278V2.08115C3.69336 1.79448 3.80669 1.52115 4.00669 1.32115C4.20669 1.12115 4.48003 1.00781 4.76669 1.00781H11.2267C11.5134 1.00781 11.7867 1.12115 11.9867 1.32115C12.1867 1.52115 12.3 1.79448 12.3 2.08115V13.9278C12.3 14.2145 12.1867 14.4878 11.9867 14.6878C11.7867 14.8878 11.5134 15.0011 11.2267 15.0011H11.2334ZM11.2334 13.9211V11.9745H4.76669V13.9211H11.2334ZM4.76669 2.08115V10.9078H11.2267V2.08115H4.76669Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeviceAccessTable);
export default __webpack_public_path__ + "static/media/ic-device-access-table.f231811f1d6af2d3e66fa429a0526c6b.svg";
export { ForwardRef as ReactComponent };